import { render, staticRenderFns } from "./inventoryItem.vue?vue&type=template&id=652d3be6&"
import script from "./inventoryItem.vue?vue&type=script&lang=js&"
export * from "./inventoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports